import React from 'react';

export const LoadingSpinner: React.FC = () => {
    return (
        <div className="flex items-center justify-center p-2">
            <div className="animate-spin rounded-full h-6 w-6 border-2 border-[#0066CC] border-t-transparent"></div>
        </div>
    );
};
